<template>
  <footer>
    <div class="inner">
      <ul>
        <li>
          公司概况
          <ul>
            <li><router-link :to="{name: 'AboutTab', params: { tab: 0 }}">关于九恒</router-link></li>
            <li><router-link :to="{name: 'AboutTab', params: { tab: 1 }}">社会责任</router-link></li>
            <li><router-link :to="{name: 'AboutTab', params: { tab: 2 }}">国际化</router-link></li>
            <li><router-link :to="{name: 'AboutTab', params: { tab: 3 }}">企业资质</router-link></li>
            <!-- <li><router-link :to="{name: 'AboutTab', params: { tab: 4 }}">合作伙伴</router-link></li> -->
          </ul>
        </li>
        <li>
          业务板块
          <ul>
            <li><router-link :to="{name: 'Busi1'}">智电设计</router-link></li>
            <li><router-link :to="{name: 'Busi2'}">智能配网</router-link></li>
            <li><router-link :to="{name: 'Busi3'}">智慧运营</router-link></li>
            <li><router-link :to="{name: 'Busi5'}">绿电低碳</router-link></li>
            <li><router-link :to="{name: 'Busi4'}">智能产品</router-link></li>
          </ul>
        </li>
        <li>
          新闻资讯
          <ul>
            <li><router-link :to="{name: 'NewsCata', params: {q: '党建工作'}}">党建工作</router-link></li>
            <li><router-link :to="{name: 'NewsCata', params: {q: '集团资讯'}}">集团资讯</router-link></li>
            <li><router-link :to="{name: 'NewsCata', params: {q: '媒体报道'}}">媒体报道</router-link></li>
            <li><router-link :to="{name: 'NewsCata', params: {q: '行业动态'}}">行业动态</router-link></li>
          </ul>
        </li>
      </ul>
      <ul>
        <li>联系电话</li>
        <li class="tel">总机 <a href="tel:00861050856300">010-50856300</a></li>
        <li class="tel">业务咨询 <a href="tel:4001199655">400-1199-655</a></li>
        <li class="icon">
          <a class="wechat"/>
          <router-link :to="{name: 'Busi'}" class="weibo"></router-link>
          <router-link :to="{name: 'Busi'}" class="linkedin"></router-link>
        </li>
      </ul>
      <dl>
        <dt>Copyright © 北京九州恒盛电力科技有限公司All Rights Reserved, 京ICP备16016567号-1</dt>
        <dd>
          <!-- <router-link :to="{name: 'Home'}">法律声明</router-link>｜
          <router-link :to="{name: 'Home'}">隐私政策</router-link>｜
          <router-link :to="{name: 'Home'}">网站地图</router-link> -->
        </dd>
      </dl>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'topNav'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
</style>
